import { logUserActivity, AnalyticsEventType } from '../services/AnalyticsService'
import useUserContextRef from '../services/useUserContextRef'
import useRoomContextRef from '../services/useRoomContextRef'
import { env } from '../services/EnvironmentVariables'

export default function useAnalytics() {
    const { userStateRef } = useUserContextRef()
    const { roomStateRef } = useRoomContextRef()

    const logUserActivityWithContext = (event: AnalyticsEventType, additionalData: Record<string, any> = {}) => {
        try {
            const userState = userStateRef.current
            const roomState = roomStateRef.current
            const username = userState.profile?.username || ''
            // FIXME: This needs to use the muse sessionId, which only the websocket server knows at the moment.
            // userState.sessionId is a livekit peer identifer.
            const sessionId = userState.sessionId || ''
            const extendedAdditionalData = {
                ...additionalData,
                userUrn: userState.userUrn,
                isGuest: userState.isGuest,
                roomUrn: roomState.roomUrn || roomState.preRoomUrn,
                isHost: roomState.isHost,
                userTier: userState.profile?.policy?._id,
                appVersion: env.APP_VERSION,
                isDesktopApp: env.IS_ELECTRON,
            }
            logUserActivity(event, username, sessionId, extendedAdditionalData)
        } catch (error) {
            console.error('Error logging user activity:', error)
        }
    }

    return {
        logUserActivityWithContext,
    }
}
